// actions.js
export const updateAccount = (newData) => ({
  type: "UPDATE_ACCOUNT_DATA",
  payload: newData,
});

export const updateTags = (tags) => ({
  type: "UPDATE_TAGS",
  payload: tags,
});

export const updateSites = (payload) => ({
  type: "UPDATE_SITES",
  payload: payload,
});

export const updateUser = (payload) => ({
  type: "UPDATE_USER",
  payload,
});

export const setLoading = (payload) => ({
  type: "SET_LOADING",
  payload,
});

export const updateOrderData = (payload) => ({
  type: "UPDATE_ORDER_DATA",
  payload,
});
